import { Flow_0_0_2 } from '@flexus/core';

export const SIL_42: Flow_0_0_2 = {
	id: '42',
	name: 'rework_job',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for SP to start job rework'
		}
	},
	startNode: '',
	nodes: {}
};
